import React from 'react';
import { IProductDetails } from '../models/ProductDetails';

export const ActiveProductContext = React.createContext<Omit<IProductDetails, 'plans'> | null>(null);
